import React, { Component } from "react";
import "./App.css";
import Header from "./header";
import axios from "axios";
import ReactGA from "react-ga";
ReactGA.initialize("UA-82826199-34");
ReactGA.pageview(window.location.pathname + window.location.search);

class App extends Component {
  initialState = {
    lat: 0,
    long: 0,
  };

  // 初期状態設定
  state = {
    lat: null,
    long: null,
    url: null,
    nowStation: null,
    nextStation: null,
    prevStation: null,
  };

  constructor(props) {
    super(props);
    this.state = { isToggleNaha: true };
    this.state = { isToggleUrasoe: true };

    this.handleClick = this.handleClick.bind(this);
    this.handleClickGetLocation = this.handleClickGetLocation.bind(this);
  }

  handleClick() {
    this.setState(function (prevState) {
      return {
        isToggleNaha: !prevState.isToggleNaha,
        isToggleUrasoe: !prevState.isToggleUrasoe,
      };
    });
  }

  getData() {
    // ユーザの現在位置を取得
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        this.setState({ lat: pos.coords.latitude, long: pos.coords.longitude }),
      (err) => console.log(err)
    );
    // console.log(this.state.lat);
    // console.log(this.state.long);
  }

  handleClickGetLocation() {
    this.getData();
    let url = `https://express.heartrails.com/api/json?method=getStations&x=${this.state.long}&y=${this.state.lat}`;
    axios.get(url, { timeout: 1000 }).then((res) => {
      this.setState({
        nowStation: res.data.response.station[0].name,
        nextStation: res.data.response.station[0].next,
        prevStation: res.data.response.station[0].prev,
      });
    });
  }

  componentDidMount() {
    this.setState({ ...this.initialState });
    this.getData();
  }

  componentDidUpdate() {
    if (this.state.lat || this.state.lat) {
      // ユーザの現在位置を取得
      navigator.geolocation.getCurrentPosition(
        (pos) =>
          this.setState({
            lat: pos.coords.latitude,
            long: pos.coords.longitude,
          }),
        (err) => console.log(err)
      );
      // console.log(this.state.lat);
      // console.log(this.state.long);
    }
  }

  render() {
    return (
      <div>
        <Header />
        <div className="pl-container">
          <button
            onClick={this.handleClickGetLocation}
            className="pl-button isWide"
          >
            現在の駅を調べる
          </button>
          <button
            onClick={this.handleClick}
            className="pl-button"
            style={{ display: this.state.nowStation == null ? "none" : "" }}
          >
            {this.state.isToggleNaha ? "那覇方面" : "浦添方面"}
          </button>
          <div className="pl-Area">
            <p
              className="pl-Area__Next"
              style={{ display: this.state.nowStation == null ? "none" : "" }}
            >
              現在の駅は
            </p>
            <p className="pl-Area__Name">{this.state.nowStation}</p>
            {this.state.nowStation == null && (
              <p className="pl-Area__Name">Get Now Location</p>
            )}
            <div
              className="pl-Area__wrap"
              style={{ display: this.state.isToggleNaha ? "none" : "" }}
            >
              <p
                className="pl-Area__Next"
                style={{ display: this.state.nowStation == null ? "none" : "" }}
              >
                次の停車駅は(那覇方面)
              </p>
              <p className="pl-Area__Name">{this.state.prevStation}</p>
            </div>

            <div
              className="pl-Area__wrap"
              style={{ display: this.state.isToggleUrasoe ? "none" : "" }}
            >
              <p className="pl-Area__Next">次の停車駅は(浦添方面)</p>
              <p className="pl-Area__Name">{this.state.nextStation}</p>
            </div>
          </div>
        </div>
        <p className="pl-link">API by HeartRails Express</p>
      </div>
    );
  }
}

export default App;
